import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useDCContext } from "@src/context";
import { useOperatorContext } from "@src/context/operatorContext";
import OperatorHooks from "@src/context/hooks/operatorHooks";
import { Icon, Loader, TextLink } from "@src/components/atoms";
import CommitmentCard from "@src/components/cards/CommitmentCard";
import RecentEventCard from "@src/components/cards/operator/RecentEventCard";
import CardContainer from "@src/components/cards/CardContainer";

const RecentActivity = () => {
  const { profile, setSelectedEvent } = useOperatorContext();
  const dc = useDCContext();
  const navigate = useNavigate();
  const industry = profile?.customer?.industry;

  const {
    data: { latestEvents } = {},
    isPending: latestEventsPending,
    error: latestEventsError,
  } = OperatorHooks.useOperatorLatestEvents(profile?.operator?.id);

  const navigateToEvents = (event) => {
    setSelectedEvent(event);
    navigate(`/dashboard/operator/events/${event.id}`);
  };

  return (
    <div className=" mb-6 md:mb-0">
      <h3 className="font-extrabold mb-4 text-center">Recent Activity</h3>
      <div className="w-full mb-2">
        {latestEventsPending ? (
          <div className="min-h-20">
            <div className="w-full h-full flex items-center justify-center">
              <Loader size="xl" />
            </div>
          </div>
        ) : latestEventsError ? (
          <div>Error fetching latest events...</div>
        ) : Array.isArray(latestEvents) && latestEvents.length > 0 ? (
          latestEvents.map((event) => (
            <div key={`${event.id}`} className="mb-3">
              <RecentEventCard
                event={event}
                industry={industry}
                getDynamicContent={dc.getDynamicReplacement}
                onEventClick={() => navigateToEvents(event)}
                trackingActionKey="OVERVIEW_RECENT_EVENT_SELECTION"
              />
            </div>
          ))
        ) : (
          <CardContainer bgColor="primary-200" padding={4}>
            <div className="flex gap-2 items-center text-left">
              {" "}
              <Icon name={"clockwise"} inline /> Signol is awaiting data...
            </div>
          </CardContainer>
        )}
      </div>
      <TextLink
        side="right"
        to="/dashboard/operator/events"
        onClick={() => navigate("/dashboard/operator/events")}
        text="More history"
        trackingActionKey="MENU_SELECTION"
      />
    </div>
  );
};

export default RecentActivity;
